import { Provider } from '@angular/core';
import { SecurityAuditDetailPageViewContractId } from '@daas-consulting/security/audit/frontend/view_contracts';
import { AuditDetailPageViewModel } from '@daas-consulting/security/audit/frontend/view_models';

export const AuditDetailPageViewModelProvider: Provider = {
  provide: SecurityAuditDetailPageViewContractId,
  useClass: AuditDetailPageViewModel,
};
